import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { Events } from '@carvana/vdp-events';
import { useSelector } from 'react-redux';
import { getGeoLocation, getUser } from '~/selectors';
import { generateCustomEventDetail } from '~/utilities/browserEvents';

const getEventEl = () => document.querySelector<HTMLElement>('#vdp-events');

function useEventDispatchers() {
  const { zip } = useSelector(getGeoLocation);
  const { isLoggedIn, userId } = useSelector(getUser);

  // Geolocation
  useSubsequentEffect(() => {
    getEventEl()?.dispatchEvent(
      new CustomEvent(Events.Geolocation, {
        detail: generateCustomEventDetail()
      })
    );
  }, [zip]);

  // User Profile
  useSubsequentEffect(() => {
    getEventEl()?.dispatchEvent(
      new CustomEvent(Events.UserProfile, {
        detail: generateCustomEventDetail()
      })
    );
  }, [isLoggedIn, userId]);
}

export default useEventDispatchers;
